import React from 'react';
import propTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { configureActions } from '../../../actions/configure.action';
import { FormGroup, FormText } from 'reactstrap';
import Datagrid from '../Datagrid';
import { Alert } from '../Common';
import helper from '../../../utils/helper';

const MonitoringPoints = (props) => {
  const { t, groupId } = props;
  const [selected, setSelected] = React.useState([]);
  const [sensors, setSensors] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  React.useEffect(() => {
    if (groupId) {
      setSelected([]);
      setLoading(true);
      props.getSensorsMVByGroup(groupId).finally(() => setLoading(false));
    }
  }, [groupId]);
  React.useEffect(() => {
    setSensors(props.configure.sensors);
  }, [props.configure.sensors]);
  React.useEffect(() => {
    setLoading(props.isFetching);
  }, [props.isFetching]);
  React.useEffect(() => {
    props.onSelect(selected);
  }, [selected]);
  const columns = [
    {
      dataField: 'location',
      text: 'Location',
      sort: true,
    },
    {
      dataField: 'name',
      text: 'Name',
      sort: true,
    },
    {
      dataField: 'parameter',
      text: 'Parameter',
      sort: true,
    },
    {
      dataField: 'textValue',
      text: 'Value',
      sort: true,
    },
    {
      dataField: 'units',
      text: 'Units',
      sort: true,
    },
    {
      dataField: 'alarmImage',
      text: 'Status',
      sort: true,
      formatter: (cell) => formatterStatus(cell),
    },
    {
      dataField: 'timeStamp',
      text: 'Time Last Updated',
      sort: true,
      isDateTime: true,
    },
  ];

  const defaultSorted = [
    {
      dataField: 'location',
      order: 'desc',
    },
  ];

  const formatterStatus = (cell) => {
    return (
      <div className="d-flex justify-content-center align-items-center">
        <img
          src={`./img/statusIcon/${cell}`}
          width={24}
          height={24}
          alt="status-icon"
          title={t(helper.getStatusIconName(cell))}
        />
      </div>
    );
  };

  const selectRow = {
    mode: 'checkbox',
    clickToSelect: true,
    selected: selected,
    onSelect: handleSelect,
    onSelectAll: handleSelectAll,
  };

  function handleSelect(row, isSelect) {
    if (isSelect) {
      setSelected([...selected, row.sensorId]);
    } else {
      setSelected(selected.filter((x) => x !== row.sensorId));
    }
  }

  function handleSelectAll(isSelect, rows) {
    const ids = rows.map((r) => r.sensorId);
    if (isSelect) {
      setSelected(ids);
    } else {
      setSelected([]);
    }
  }

  if (groupId === undefined) {
    return (
      <FormGroup>
        <FormText>{t('Please choose group above')}</FormText>
      </FormGroup>
    );
  }
  return (
    <>
      {props.invalid ? <Alert.Error text={props.error} /> : null}
      <Datagrid
        datagridProps={{
          keyField: 'sensorId',
          data: sensors,
          loading,
          columns,
          defaultSorted,
          selectRow,
        }}
        noExport
      />
    </>
  );
};

function mapStateToProps(state) {
  return {
    configure: state.configure,
  };
}

export default withTranslation('app')(
  connect(mapStateToProps, configureActions)(MonitoringPoints),
);

MonitoringPoints.propTypes = {
  onSelect: propTypes.func.isRequired,
};
